
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs display-lift-v3-container">
    <div class="cards-holder">
        <div class="card card2 mRight" #chartcontainer>
            <div class="c-portlet__header">
                <div class="o-stack__cell">
                    <h5>{{sectiontitle}}</h5>
                </div>
            </div>
            <div class="c-portlet__content u-pt-small" id="barChartContainer" (window:resize)="onResize($event)">
                <div class="o-stack o-stack--center  o-stact_ImgSpecs" *ngIf="campaignCarouselItem">
                    <div class="charts-container product-lift-chart-container">
                        <div class="chart-layout">
                            <div [id]="'campaign'+i" class="individual-chart">
                                <app-chart-v3 class="individual-chart" [chartData]="campaignCarouselItem" [svgWidth]="svgWidth" [barChartConfiguration]="barChartDataConfiguration" [svgHeight]="svgHeight"></app-chart-v3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-data-container" *ngIf="!hasData">
                <app-loader [showLoader]=showLoad></app-loader>
                <div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
            </div>
        </div>
        <div class="card card1 mLeft lift-right">
            <div class="c-portlet__header lift-header">
                <div class="o-stack__cell">
                    <h5>Lift Trend By Campaign</h5>
                </div>
            </div>
            <div class="" *ngIf="campaignsList.length > 0">
                <app-datatable-carousel [sectionclass]="sectionclass" [campaignsData]="campaignsList" [sectiontitle]="sectiontitle" [datatableconfig]="devicedatatableconfig"
                    [key]="timeserieskey" (updateGraph)="updateGraph($event)"></app-datatable-carousel>
            </div>
            <div class="no-data-container" *ngIf="!hasData">
                <app-loader [showLoader]=showLoad></app-loader>
                <div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
            </div>
        </div>
    </div>
</div>
